import React, { useState } from 'react';

const GATE_PASSWORD = 'Notorious78!';
const GATE_KEY = 'aos_demo_gate_v1';

export const isGateUnlocked = () => {
  try { localStorage.removeItem(GATE_KEY); } catch (_e) { /* ignore */ }
  return false;
};

export default function DemoGate({ onUnlock }) {
  const [pw, setPw] = useState('');
  const [error, setError] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (pw === GATE_PASSWORD) {
      onUnlock();
    } else {
      setError(true);
      setTimeout(() => setError(false), 1800);
    }
  };

  return (
    <div
      data-testid="demo-gate"
      style={{
        position: 'fixed', inset: 0, zIndex: 10000, background: '#060E1C',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px',
        fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
      }}
    >
      <div style={{ width: '100%', maxWidth: '380px', textAlign: 'center' }}>
        <img src="/logo.png" alt="AssistivOS" style={{ height: 44, width: 'auto', display: 'block', margin: '0 auto 8px' }} />
        <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '10px', letterSpacing: '0.2em', color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', marginBottom: '32px' }}>
          Private Demo Access
        </div>
        <form onSubmit={submit} noValidate>
          <input
            type="password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            placeholder="Enter access password"
            autoFocus
            data-testid="demo-gate-input"
            style={{
              width: '100%', background: 'rgba(255,255,255,0.05)', borderRadius: '10px',
              border: `1px solid ${error ? '#F87171' : 'rgba(255,255,255,0.14)'}`,
              padding: '14px 16px', color: '#fff', fontSize: '15px', textAlign: 'center',
              outline: 'none', marginBottom: '12px', letterSpacing: '0.08em',
            }}
          />
          <button
            type="submit"
            data-testid="demo-gate-submit"
            style={{
              width: '100%', background: '#F97316', color: '#09152A', border: 'none',
              borderRadius: '10px', padding: '14px', fontWeight: 800, fontSize: '14px', cursor: 'pointer',
            }}
          >Enter →</button>
          <div data-testid="demo-gate-error" style={{ height: '18px', marginTop: '12px', fontSize: '12px', color: '#F87171', fontFamily: "'Lato', sans-serif" }}>
            {error ? 'Incorrect password — try again.' : ''}
          </div>
        </form>
        <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '10px', color: 'rgba(255,255,255,0.45)', marginTop: '16px' }}>
          HDG University · Tech Tradesmith Institute
        </div>
      </div>
    </div>
  );
}
